<template>
	<AppContentLayout :key="inboxId" class="app-content-layout">
		<Row class="height-100 width-100">
			<Col class="left height-100">
				<InboxTopBar :inboxId="inboxId" class="mb-5" />
				<InboxNotificationsMenu :alertIdToStickAtTop="alertIdToStickAtTop" :inboxId="inboxId" />
			</Col>
			<Col class="flex-justify-center width-100">
				<router-view />
			</Col>
		</Row>
	</AppContentLayout>
</template>

<script>
import InboxTopBar from '@/components/Inbox/InboxTopBar.vue';
import AppContentLayout from '../AppLayout/AppContentLayout.vue';
import InboxNotificationsMenu from '@/components/Inbox/InboxNotificationsMenu.vue';
export default {
	name: 'Inbox',
	props: {
		stickToTop: { type: Boolean },
		inboxId: { type: [String, Number] },
		alertId: { type: [String, Number] },
	},
	components: { InboxTopBar, AppContentLayout, InboxNotificationsMenu },
	computed: {
		alertIdToStickAtTop() {
			return this.stickToTop ? this.alertId : null;
		},
	},
};
</script>

<style scoped lang="scss">
.app-content-layout {
	height: 100% !important;
	padding: 0 0 0px 0 !important;
}
.left {
	min-width: 500px;
	max-width: 500px;
	border-right: 1px solid var(--border-color);
}
</style>
